import { appendParams } from '@utils/func'
import { API } from '@utils/axios'
import { IAPI } from 'AppTypes'

class ArticleManagementAPI implements IAPI {
  prefix = '/ArticleManagement'

  fetchList (params: TArticleManagementAPI.Params.FetchList) {
    const IsPublish = typeof params.IsPublish === 'string' && params.IsPublish !== '' ? Boolean(Number(params.IsPublish)) : params.IsPublish
    const url = appendParams(`${this.prefix}/articles`, { ...params, IsPublish })
    return API.get<TArticleManagementDetail.TState['articleList']>(url)
  }

  fetchSingle (id: string) {
    return API.get<TArticleManagementDetail.TState['articleDetail']>(`${this.prefix}/${id}`)
  }

  deleteArticle (id: string) {
    return API.delete<TArticleManagementDetail.TState['articleDetail']>(`${this.prefix}/${id}`)
  }
}

export const articleManagementAPI = new ArticleManagementAPI()
